"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.http = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// axios uses Linux symbolic error name for timeout response.
var TIMEOUT_CODE = 'ECONNABORTED';

var getDefaultErrorForStatus = function getDefaultErrorForStatus(status) {
  // We can eventually show different default messages based on server status code.
  // For now I am just returning one default error message regardless of status.
  // You can override this default message by sending an error payload from the server,
  // or by providing a custom error message in the correct reducer.
  switch (status) {
    case 404:
      return 'Resource not found.';

    case 422:
    case 401:
    default:
      return "Oops! There's been a problem. Please try again or reach out to support@mapistry.com for assistance.";
  }
};

var http = _axios["default"].create({
  withCredentials: true
});

exports.http = http;
http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  var errorMessage;
  var status;
  var timeout = false;

  if (error.code === TIMEOUT_CODE) {
    timeout = true;
  } else if (error.response) {
    errorMessage = error.response.data;
    status = error.response.status;
  } else if (error.request) {// The request was made but no response was received
    // no status or error message here, will fall back to default error
  } else {
    errorMessage = error.message;
  } // eslint-disable-next-line prefer-promise-reject-errors


  return Promise.reject({
    data: typeof errorMessage === 'string' ? errorMessage : // eslint-disable-next-line @typescript-eslint/no-use-before-define
    getDefaultErrorForStatus(status),
    status: status,
    timeout: timeout,
    // TODO for dev purposes only, debugging timeout codes
    code: error === null || error === void 0 ? void 0 : error.code
  });
});